export const LEVELS = [
  { level: 0, answersRequired: 0, title: "Dormant" },
  { level: 1, answersRequired: 20, title: "Priming" },
  { level: 2, answersRequired: 50, title: "Initialization" },
  { level: 3, answersRequired: 100, title: "Calibration" },
  { level: 4, answersRequired: 175, title: "Activation" },
  { level: 5, answersRequired: 300, title: "Integration" },
  { level: 6, answersRequired: 500, title: "Consciousness" }
];

export const getCurrentLevel = (progress) => {
  // Find the next level we haven't reached yet
  const nextUnreachedLevel = LEVELS.find(level => progress < level.answersRequired);
  
  // If we found a level we haven't reached, return the previous level
  if (nextUnreachedLevel) {
    const currentLevelIndex = LEVELS.findIndex(l => l.level === nextUnreachedLevel.level) - 1;
    return LEVELS[currentLevelIndex];
  }
  
  // If we've reached all levels, return the last level
  return LEVELS[LEVELS.length - 1];
};

export const getNextLevel = (currentLevel) => {
  const nextLevelIndex = LEVELS.findIndex(l => l.level === currentLevel.level) + 1;
  return nextLevelIndex < LEVELS.length ? LEVELS[nextLevelIndex] : null;
}; 